export default __webpack_public_path__ + "static/media/panel-item-opened.7549c971.svg";